import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs } from "react-bootstrap";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { baseUrl } from "../../api/common";
import axios from "axios";
import { convertDBDate, convertCertificateDate } from './common';
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Loader from "../common/Loader";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { GetInvoiceData } from "../UserMembershipApplication/Api/services/Webservices";
import Invoice from "../Template/invoice";
import MembershipCertificate from "./certificate/membership-certificate";
import FMASCertificate from "./certificate/fmas-certificate";

const ViewMembershipApplicationComponent = ({
  handleAfterChangeStatus,
  handleChangeStatusModal,
  applicationId,
  applicationName,
  memberId,
  viewPopupStatus,
  handleAddPopup,
  handleViewMemberPopup,
  fetchApplicationMembersData
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [certificateDropdownOpen, setCertificateDropdownOpen] = useState(false);

  const certificateToggle = () => setCertificateDropdownOpen((prevState) => !prevState);

  const [viewMemberActivityPopupStatus, setViewMemberActivityPopupStatus] = useState(false);

  const handleViewMemberActivityPopup = (status) => {
    setViewMemberActivityPopupStatus(status);
  };

  const handleOpenAddMemberActivityPopup = () => {
    handleAddPopup(true, "Update", memberId, applicationId);
    handleViewMemberPopup(false);
  };

  const [memberDetails, setMemberDetails] = useState({});
  const [fmasDetails, setFMASDetails] = useState({});
  const [clinicAddress, setClinicAddress] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [memberPaymentDetails, setMemberPaymentDetails] = useState([]);
  const [memberDetailsStatus, setMemberDetailsStatus] = useState(false);
  const fetchMemberDetailsData = async () => {
    setMemberDetailsStatus(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_detail`,
        { id: memberId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setMemberDetails(response.data.data[0]);
        setFMASDetails(response.data.fmas_data[0]);
        setClinicAddress(response.data.clinic);
        setProcedures(response.data.work_exp);
        setMemberPaymentDetails(response.data.payment_status);
        console.log(response.data, "fetchMemberDetailsData");
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
      setMemberDetailsStatus(false);
    }
  };

  const formatTimestamp = (isoString) => {
    const istDate = new Date(new Date(isoString).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    return istDate.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const [applicationStatusData, setApplicationStatusData] = useState([]);
  const fetchApplicationStatusData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_status_master`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        setApplicationStatusData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [memberActivityData, setMemberActivityData] = useState([]);
  const fetchMemberActivityData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/get_member_activity`,
        { member_id: memberId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
      if (response.data.status) {
        setMemberActivityData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [memberNotesData, setMemberNotesData] = useState([]);
  const fetchMemberNotesData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/get_member_notes`,
        { member_id: memberId },
        {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        setMemberNotesData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const [memberActivityLogData, setMemberActivityLogData] = useState([]);
  const fetchMemberActivityLogData = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/get_member_activity_log`,
        { id: memberId },
        {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        setMemberActivityLogData(response.data.data);
      } else {
        setMemberActivityLogData([]);
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const htmlRef = useRef(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [clickMergeFiles, setClickMergeFiles] = useState(false);

  const mergeFiles = async () => {
    setClickMergeFiles(true);
    const mergedPdf = await PDFDocument.create();
    const pageWidth = 595;
    const pageHeight = 842;

    const htmlElement = htmlRef.current;
    if (htmlElement) {
      const h2Element = htmlElement.querySelector(".overflow_auto");
      if (h2Element) {
        h2Element.classList.remove("overflow_auto");
        h2Element.classList.add("white_space_break");
      }

      const buttons = htmlElement.querySelectorAll("button");
      buttons.forEach(btn => (btn.style.display = "none"));

      const hiddenElements = htmlElement.querySelectorAll(".hide-document-in-pdf");
      hiddenElements.forEach(el => (el.style.display = "none"));

      const canvas = await html2canvas(htmlElement, { useCORS: true, scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      buttons.forEach(btn => (btn.style.display = "block"));

      const htmlPdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [pageWidth, pageHeight],
      });

      let imgWidth = htmlPdf.internal.pageSize.getWidth();
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let yPos = 0;

      while (yPos < imgHeight) {
        htmlPdf.addImage(imgData, "PNG", 0, -yPos, imgWidth, imgHeight);
        yPos += pageHeight;
        if (yPos < imgHeight) htmlPdf.addPage();
      }

      const htmlPdfBytes = htmlPdf.output("arraybuffer");
      const htmlPdfDoc = await PDFDocument.load(htmlPdfBytes);

      const htmlPages = await mergedPdf.copyPages(htmlPdfDoc, htmlPdfDoc.getPageIndices());
      htmlPages.forEach(page => mergedPdf.addPage(page));
    }

    const loadPdf = async (url) => {
      const pdfBytes = await fetch(url).then(res => res.arrayBuffer());
      return PDFDocument.load(pdfBytes);
    };

    const addImageWithHeader = async (url, title, pdfDoc) => {
      const imageBytes = await fetch(url).then(res => res.arrayBuffer());
      const imageType = url.endsWith(".png") ? "png" : "jpeg";
      const embeddedImage = imageType === "png"
        ? await pdfDoc.embedPng(imageBytes)
        : await pdfDoc.embedJpg(imageBytes);

      const padding = 30;
      const headerHeight = 30;
      const availableHeight = pageHeight - padding * 2 - headerHeight;

      const imgWidth = pageWidth - padding * 2;
      let imgHeight = (embeddedImage.height * imgWidth) / embeddedImage.width;

      if (imgHeight > availableHeight) {
        const scaleFactor = availableHeight / imgHeight;
        imgHeight *= scaleFactor;
      }

      const page = pdfDoc.addPage([pageWidth, pageHeight]);

      page.drawText(title, {
        x: padding,
        y: pageHeight - padding,
        size: 16
      });

      page.drawImage(embeddedImage, {
        x: padding,
        y: pageHeight - padding - headerHeight - imgHeight,
        width: imgWidth,
        height: imgHeight,
      });
    };

    const files = [
      memberDetails.mci_certificate && {
        url: `${memberDetails.mci_certificate}`,
        type: "NMC Certificate",
      },
      memberDetails.pg_degree_certificate && {
        url: `${memberDetails.pg_degree_certificate}`,
        type: "Post Graduation Degree Certificate",
      },
      memberDetails.asi_member_certificate && {
        url: `${memberDetails.asi_member_certificate}`,
        type: "ASI Membership Certificate",
      },
      memberDetails.active_license && {
        url: `${memberDetails.active_license}`,
        type: "Active License for Practicing Surgeons",
      },
      memberDetails.letter_hod && {
        url: `${memberDetails.letter_hod}`,
        type: "Letter from HOD",
      },
      memberDetails.mbbs_degree_certificate && {
        url: `${memberDetails.mbbs_degree_certificate}`,
        type: "MBBS Degree Certificate",
      },
    ].filter(Boolean);

    for (const file of files) {
      if (file.url.endsWith(".pdf")) {
        const pdfDoc = await loadPdf(file.url);
        const pages = await pdfDoc.getPages();
        const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());

        copiedPages.forEach((page, index) => {
          const scale = pageWidth / page.getWidth();
          page.scale(scale, 1);

          if (index === 0) {
            page.drawText(file.type, {
              x: 40,
              y: pageHeight - 50,
              size: 16
            });
          }
          mergedPdf.addPage(page);
        });
      } else {
        await addImageWithHeader(file.url, file.type, mergedPdf);
      }
    }

    const finalPdfBytes = await mergedPdf.save();
    const blob = new Blob([finalPdfBytes], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    setPdfBlobUrl(blobUrl);
    handleViewMemberPopup(false);
    window.open(blobUrl, "_blank");
    setClickMergeFiles(false);
  };

  const [notesValue, setNotesValue] = useState("");
  const handleSaveMemberNotes = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/member_notes_update`,
        {
          member_id: memberId,
          notes: notesValue,
          login_user_id: localStorage.getItem("loginUserId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
      if (response.data.status) {
        showToast(response.data.message, "success");
        fetchMemberNotesData();
        setNotesValue("");
      } else {
        console.error("Error: Failed to fetch user data");
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const filterActions = (status) => {
    return (id) => {
      if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12].includes(status) && id === status) return false;
      if (status === 10) return id === 11;
      if ([10, 13, 14, 15, 16, 17, 18].includes(id)) return false;
      if (status === 12 && [1, 3, 11].includes(id)) return false;
      if ((status === 3 || status === 6) && [11, 12].includes(id)) return false;
      if (status === 4 && id === 10) return false;
      return true;
    };
  };

  const workExpInYears = (from, to) => {
    const year1 = new Date(from).getFullYear();
    const year2 = new Date(to).getFullYear();
    return year2 - year1;
  };

  const [invoiceData, setInvoiceData] = useState(null);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [invoiceError, setInvoiceError] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);

  const handleInvoiceClick = async () => {
    setLoadingInvoice(true);
    setInvoiceError(null);

    try {
      const formData = new FormData();
      formData.append("id", memberId);

      const data = await GetInvoiceData(formData);
      setInvoiceData(data);
      setShowInvoice(true);
    } catch (error) {
      setInvoiceError(error.message || "Error fetching invoice data");
    } finally {
      setLoadingInvoice(false);
    }
  };

  const handleCloseInvoice = () => {
    setShowInvoice(false);
  };

  const [showMembershipCertificate, setShowMembershipCertificate] = useState(false);
  const [showFMASCertificate, setShowFMASCertificate] = useState(false);
  const [certificateDetails, setCertificateDetails] = useState({});
  const handleMembershipCertificateClick = async (applicationDate) => {
    try {
      const response = await axios.post(`${baseUrl}/api/certificate_data_list`,
        { member_apply_date: applicationDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
      if (response.data.status) {
        setCertificateDetails(response.data.data[0]);
        setShowMembershipCertificate(true);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleCloseMembershipCertificate = () => {
    setShowMembershipCertificate(false);
  };
  const handleOpenFMASCertificate = () => {
    setShowFMASCertificate(true);
  };
  const handleCloseFMASCertificate = () => {
    setShowFMASCertificate(false);
  };

function formatPaymentDateTime(dateString) {
  if (!dateString) return "N/A";
  
  const date = new Date(dateString);

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "UTC"
  }).format(date).replace(",", "");
}

  const handleCheckChangeStatusModal = (status, id, applicationStatus) => {
    if (id === 1) {
      handleChangeApplicationStatus(id);
    } else {
      handleChangeStatusModal(status, id, applicationStatus);
    }
  };

  const handleChangeApplicationStatus = async (statusId) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_activity_update`,
        {
          message: '',
          password: '',
          member_id: memberId,
          application_status: statusId,
          login_user_id: localStorage.getItem('loginUserId'),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );
      if (response.data.status) {
        showToast(response.data.message, 'success');
        handleViewMemberPopup(false);
        fetchApplicationMembersData();
      } else {
        console.error('Error: Failed to fetch user data');
        showToast(response.data.message, 'error');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
      showToast('An error occurred while updating status', 'error');
    }
  };

  const getInvoiceNumber = (applicationNo) => {
      return`INV-${applicationNo}`;
  };

  useEffect(() => {
    if (memberId) {
      fetchMemberDetailsData();
      fetchMemberActivityData();
      fetchMemberActivityLogData();
      fetchMemberNotesData();
    }
    fetchApplicationStatusData();
  }, [memberId, viewPopupStatus]);

  return (
    <>
      <ToastMessage />
      {viewPopupStatus && (
        <div
          className={`extraspace_search_div search_div${viewPopupStatus ? " open" : ""}`}
        >
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>View Member</h3>
              <div className="input-group-append d-flex gap-10">
                {(memberDetails && memberDetails.membership_no) || (fmasDetails && fmasDetails.certificate_file)?
                  <div>
                    <Dropdown isOpen={certificateDropdownOpen} toggle={certificateToggle}>
                      <DropdownToggle caret className='btn-default'>Certificates</DropdownToggle>
                      <DropdownMenu container="body">
                        {memberDetails && memberDetails.membership_no &&
                        <DropdownItem onClick={() => handleMembershipCertificateClick(memberDetails.member_reg_date)}>
                          Membership 
                        </DropdownItem>}
                        {fmasDetails && fmasDetails.certificate_file &&
                        <DropdownItem onClick={() => handleOpenFMASCertificate()}>
                          FMAS
                        </DropdownItem>}
                      </DropdownMenu>
                    </Dropdown>
                  </div>:<div></div>}  
                <div>
                  <button
                    onClick={handleViewMemberActivityPopup}
                    className="saveand_proced_button btn btn-outline-info btn-block"
                    type="button"
                  >
                    Activity{" "}
                  </button>
                </div>
                {(memberDetails && memberDetails.membership_no) && (memberPaymentDetails && memberPaymentDetails.length > 0 ) ?
                  <button
                    onClick={handleInvoiceClick}
                    className="btn btn-outline-success btn-sm"
                  >
                    View Invoice
                  </button>:<div></div>}
                {memberDetails && memberDetails.membership_no ?
                  <div>
                    <button
                      className="btn btn-outline-info btn-block saveand_proced_button"
                      type="button"
                      disabled={clickMergeFiles}
                      onClick={() => mergeFiles()}
                    >
                    <i className="fa fa-file-pdf-o" aria-hidden="true" /> <span className="flo-txt-none"> {clickMergeFiles ? 'Downloading...' : 'Download'}  
                      {clickMergeFiles && <i className="fa fa-spinner fa-spin" aria-hidden="true"/>}
                    </span>
                      {/* <i className="fa fa-file-pdf-o" /> Download */}
                    </button>
                  </div>:<div></div>
                }
                <div>
                  <button
                    onClick={() => handleOpenAddMemberActivityPopup()}
                    className="saveand_proced_button btn btn-outline-info btn-block"
                    type="button"
                  >
                    <i className="fa fa-edit" /> Edit{" "}
                  </button>
                </div>
                <span
                  onClick={() => handleViewMemberPopup(false)}
                  className="search_toggle btn btn-danger"
                >
                  <i className="fa fa-times" />
                </span>
              </div>
            </div>
            {!memberDetailsStatus && memberDetails ? (
              <div ref={htmlRef} className="table-responsive">
                <div className="body  application_body_side">
                  <fieldset>
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className={`${clickMergeFiles ? "height_pdf_1" : "height_pdf_0"}`}></div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-2">
                            <div>
                              {memberDetails.profile && (
                                <img
                                  src={`${memberDetails.profile}`}
                                  width="80"
                                  height="80"
                                  className="img-thumbnail rounded-circle width_profile_image"
                                  alt="person"
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-10">
                            <div className="application_id_date_flex pb-1">
                              <div>
                                <h5 className="text-muted">
                                  <b>
                                    {memberDetails.salutation || memberDetails.first_name || memberDetails.middle_name || memberDetails.last_name
                                      ? `${memberDetails.salutation || ''} ${memberDetails.first_name || ''} ${memberDetails.middle_name || ''} ${memberDetails.last_name || ''}`
                                          .trim()
                                          .replace(/\s+/g, ' ')
                                      : 'N/A'}
                                  </b>
                                </h5>
                              </div>
                              {memberDetails.application_no &&
                              <div className="d-flex gap-15">
                                <div>
                                  <div className="mb-2 bg-info text-white cust-pad ">{memberDetails.status_name}</div>
                                </div>
                                <div>
                                  <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                    <DropdownToggle caret className='btn-default'>My Action</DropdownToggle>
                                    <DropdownMenu container="body">
                                      {applicationStatusData
                                        .filter((action) => filterActions(memberDetails.application_status)(action.id))
                                        .map((action) => (
                                          <DropdownItem key={action.id} onClick={() => handleCheckChangeStatusModal(true, action.id, action.status_name)}>
                                            {action.status_name}
                                          </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>
                              </div>}
                            </div>
                            <div className="application_id_date_flex">
                              <div className="application_flex_div">
                                <div>
                                  <small className="text-muted">
                                    <b>Application No:</b>
                                  </small>
                                  <p>{` ${memberDetails.application_no}`}</p>
                                </div>
                                <div>
                                  <small className="text-muted">
                                    <b>Membership Number:</b>
                                  </small>
                                  <p>{` ${memberDetails.membership_no || "N/A"}`}</p>
                                </div>
                                {memberPaymentDetails.length > 0 && (
                                  <div>
                                    <small className="text-muted">
                                      <b>Payment Status:</b>
                                    </small><br />                                    
                                    <span className={`badge ${memberPaymentDetails[memberPaymentDetails.length - 1]?.payment_status_id === 1 ?"badge-success" : "badge-danger"} ml-0 mr-0`}>{memberPaymentDetails[memberPaymentDetails.length - 1]?.payment_status_name}</span>
                                  </div>
                                )}
                              </div>
                              <div>
                                <small className="text-muted">
                                  <b>Application Date:</b>{" "}
                                </small>
                                <p>
                                  {convertDBDate(memberDetails.created_on)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`${clickMergeFiles ? "min_height_120" : "min_height_0"}`}>
                        <div className="col-md-12 pt-3 pb-2">
                          <div className="row">
                            <div className="col-md-8">
                              <small className="text-muted">
                                <b>To</b>{" "}
                              </small>
                              <p>
                                The Honorary Secretary General,
                                <br />
                                Association of Minimal Access Surgeons of India
                                (AMASI)
                              </p>
                            </div>
                          </div>
                          <small className="text-muted">
                            <b>Dear Sir,</b>{" "}
                          </small>
                          <p>
                            I wish to become a {memberDetails.application_name} of the
                            Association and if selected, I agree to abide by the
                            rules and regulations of the Association. I hereby
                            declare that the information provided by me is correct
                            and if found incorrect my membership may be forfeited.
                          </p>
                        </div>
                        <div className="col-md-12">
                          <div className="card">
                            <div className="header">
                              <h2>Info</h2>
                            </div>
                            <div className="body">
                              <div className="row">
                               {memberDetails.salutation &&
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Name Salutation:</b>{" "}
                                  </small>
                                  <p>{memberDetails.salutation || "N/A"}</p>
                                </div>}
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>First Name:</b>{" "}
                                  </small>
                                  <p>{memberDetails.first_name || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Middle Name: </b>
                                  </small>
                                  <p>{memberDetails.middle_name || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Last Name: </b>
                                  </small>
                                  <p>{memberDetails.last_name || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Father's Name: </b>
                                  </small>
                                  <p>{memberDetails.father_name || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Date of Birth: </b>
                                  </small>
                                  <p>
                                    {memberDetails.dob?convertDBDate(memberDetails.dob) : "N/A"}
                                  </p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Date of Joining: </b>
                                  </small>
                                  <p>
                                    {memberDetails.joining_date?convertDBDate(memberDetails.joining_date) : "N/A"}          
                                  </p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Email address: </b>
                                  </small>
                                  <p>{memberDetails.email || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Mobile: </b>
                                  </small>
                                  <p>{memberDetails.mobile || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Nationality: </b>
                                  </small>
                                  <p>{memberDetails.nationality || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Gender: </b>
                                  </small>
                                  <p>{memberDetails.gender || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>AGE: </b>
                                  </small>
                                  <p>{memberDetails.age || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>City / District: </b>
                                  </small>
                                  <p>{memberDetails.city || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>State: </b>
                                  </small>
                                  <p>{memberDetails.state_name || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Zone: </b>
                                  </small>
                                  <p>{memberDetails.zone || "N/A"}</p>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted">
                                    <b>Country: </b>
                                  </small>
                                  <p>{memberDetails.country_name || "N/A"}</p>
                                </div>
                                <div className="col-12">
                                  <small className="text-muted">
                                    <b>Permanent Address: </b>
                                  </small>
                                  <p>
                                    {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""}, ${memberDetails.city || ""}, ${memberDetails.state_name || ""}, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""}`}
                                  </p>
                                </div>
                                <div className="col-12">
                                  <small className="text-muted">
                                    <b>Mailing Address:</b>{" "}
                                  </small>
                                  <p>
                                    {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""}, ${memberDetails.city || ""}, ${memberDetails.state_name || ""}, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""}`}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className={`${clickMergeFiles ? "height_pdf_15" : "height_pdf_0"}`}></div>
                      </div>
                      <div className="col-md-12">
                        <div className="table_profile_list_border ">
                          <div className="card">
                            <div className="header">
                              <h2>Qualifications </h2>
                            </div>
                            <div className={`body ${clickMergeFiles ? "white_space_break" : "overflow_auto"}`}>
                              <table
                                id="row-table"
                                className="table table-striped"
                              >
                                <thead>
                                  <tr>
                                    <th>Qualification Name</th>
                                    <th>Degree</th>
                                    <th>College</th>
                                    <th>University</th>
                                    <th>Year of Passing</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>MBBS</td>
                                    <td>N/A</td>
                                    <td>
                                      {memberDetails.edu_undergrad_college || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_undergrad_university || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_undergrad_year || "N/A"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Post Graduation</td>
                                    <td>
                                      {memberDetails.edu_postgrad_degree || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_postgrad_college || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_postgrad_university || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_postgrad_year || "N/A"}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Super Speciality</td>
                                    <td>
                                      {memberDetails.edu_superspecialty_degree || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_superspecialty_college || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_superspecialty_university || "N/A"}
                                    </td>
                                    <td>
                                      {memberDetails.edu_superspecialty_year || "N/A"}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="body">
                            <div className="row">
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>NMC/State Medical Council number: </b>
                                </small>
                                <p>
                                  {memberDetails.mci_council_number || "N/A"}
                                </p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>NMC State: </b>
                                </small>
                                <p>
                                  {memberDetails.mci_council_state_name || "N/A"}
                                </p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>IMR Number: </b>
                                </small>
                                <p>{memberDetails.imr_reg_no || "N/A"}</p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>Any other international Organisations: </b>
                                </small>
                                <p>
                                  {memberDetails.other_inter_organisation || "N/A"}
                                </p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>Please Mention (If others): </b>
                                </small>
                                <p>{memberDetails.other_inter_organisation_value || "N/A"}</p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>ASI Registration Number: </b>
                                </small>
                                <p>
                                  {memberDetails.asi_membership_no || "N/A"}
                                </p>
                              </div>
                              <div className="col-6">
                                <small className="text-muted">
                                  <b>ASI State: </b>
                                </small>
                                <p>{memberDetails.asi_state_name || "N/A"}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className={`${clickMergeFiles ? "height_pdf_30" : "height_pdf_0"}`}></div>
                          </div>
                        </div>
                        <div className="table_profile_list_border ">
                          <div className="card">
                            <div className="header">
                              <h2>Work Experience </h2>
                            </div>
                            <div className={`body ${clickMergeFiles ? "white_space_break" : "overflow_auto"}`}>
                              <table
                                id="row-table"
                                className="table table-striped"
                              >
                                <thead>
                                  <tr>
                                    <th>Position</th>
                                    <th>Experience (From)</th>
                                    <th>Experience (To)</th>
                                    <th>Total Experience (Years)</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {procedures && procedures.length > 0 ? (
                                    procedures.map((procedure, index) => (
                                      <tr key={index}>
                                        <td>
                                          {procedure.work_procedure || "NA"}
                                        </td>
                                        <td>
                                          {procedure.no_of_procedures1 || "NA"}
                                        </td>
                                        <td>
                                          {procedure.no_of_procedures2 || "NA"}
                                        </td>
                                        <td>
                                          {workExpInYears(procedure.no_of_procedures1, procedure.no_of_procedures2) || "NA"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4" className="text-center">
                                        No procedure data available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className={`${clickMergeFiles ? "height_pdf_1" : "height_pdf_0"}`}></div>
                        </div>
                        <div className="table_profile_list_border ">
                          <div className="card">
                            <div className="header">
                              <h2>Clinic / Hospital Address</h2>
                            </div>
                            <div className={`body ${clickMergeFiles ? "white_space_break" : "overflow_auto"}`}>
                              <table
                                id="row-table"
                                className="table table-striped"
                              >
                                <thead>
                                  <tr>
                                    <th>Clinic Name</th>
                                    <th>Address</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Pin</th>
                                    <th>Landline</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {clinicAddress && clinicAddress.length > 0 ? (
                                    clinicAddress.map((clinic, index) => (
                                      <tr key={index}>
                                        <td>{clinic.clinic_name || "NA"}</td>
                                        <td>
                                          {clinic.clinic_address_one || clinic.clinic_address_two
                                            ? `${clinic.clinic_address_one || ''} ${clinic.clinic_address_two || ''}`.trim().replace(/\s+/g, ' ')
                                            : 'N/A'}
                                        </td>
                                        <td>
                                          {clinic.clinic_country_name || "NA"}
                                        </td>
                                        <td>
                                          {clinic.clinic_state_name || "NA"}
                                        </td>
                                        <td>{clinic.clinic_city || "NA"}</td>
                                        <td>
                                          {clinic.clinic_pin_code || "NA"}
                                        </td>
                                        <td>
                                          {clinic.clinic_stdcode
                                            ? `(${clinic.clinic_stdcode}) ${clinic.clinic_landline}`
                                            : clinic.clinic_landline || "NA"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="7" className="text-center">
                                        No clinic data available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="table_profile_list_border hide-document-in-pdf">
                          <div className="card">
                            <div className="header">
                              <h2>Documents</h2>
                            </div>
                            <div className={`body ${clickMergeFiles ? "white_space_break" : "overflow_auto"}`}>
                              <table
                                id="row-table"
                                className="table table-striped"
                              >
                                <thead>
                                  <tr>
                                    <th>Document Name</th>
                                    <th className="">File</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {([1, 2, 6].includes(
                                    memberDetails.application_id
                                  ) && `${memberDetails.country}`==="101") && (
                                      <tr>
                                        <td>NMC Certificate</td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.mci_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                                {([1, 2, 3, 6].includes(
                                  memberDetails.application_id
                                )|| `${memberDetails.country}`!=="101") && (
                                      <tr>
                                        <td>
                                          Post Graduation Degree Certificate
                                        </td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.pg_degree_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                              {([1, 5, 6].includes(
                                memberDetails.application_id
                              )&& `${memberDetails.country}`==="101") &&  (
                                      <tr>
                                        <td>ASI Membership Certificate</td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.asi_member_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                              {([3].includes(
                                memberDetails.application_id
                              )|| `${memberDetails.country}`!=="101") && (
                                      <tr>
                                        <td>
                                          Active License for Practicing Surgeons
                                        </td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.active_license}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                              {([4].includes(
                                memberDetails.application_id
                              )&& `${memberDetails.country}`==="101") &&  (
                                      <tr>
                                        <td>Letter from HOD</td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.letter_hod}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                              {([4].includes(
                                memberDetails.application_id
                              ) && `${memberDetails.country}`==="101") && (
                                      <tr>
                                        <td>MBBS Degree certificate</td>
                                        <td className="text-wecenter">
                                          <a
                                            href={`${memberDetails.mbbs_degree_certificate}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-info btn-block width-fit"
                                          >
                                            View Document
                                          </a>
                                        </td>
                                      </tr>
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        {memberPaymentDetails && memberPaymentDetails.length > 0 && (
                          <div className="card">
                            <div className="header">
                              <h2>Payment Details</h2>
                            </div>
                            {memberPaymentDetails.map((payment, index) => (
                              <div className="body mb-3">
                                <div className="row">
                                  <React.Fragment key={payment.id || index}>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment ID: </b>
                                      </small>
                                      <p>{payment.payment_id || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment Status: </b>
                                      </small>
                                      <p><span className={`badge ${payment.payment_status_id === 1 ?"badge-success" : "badge-danger"} ml-0 mr-0`}>{payment.payment_status_name || "N/A"}</span></p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Paid by: </b>
                                      </small>
                                      <p>{payment.customerName || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment Date & Time: </b>
                                      </small>
                                      <p>
                                        {payment.created_on
                                          ? formatPaymentDateTime(payment.created_on)
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Amount: </b>
                                      </small>
                                      <p>{payment.amount ? `${payment.currency}${payment.amount}` : "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment Method: </b>
                                      </small>
                                      <p>{payment.payment_name || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment Gateway: </b>
                                      </small>
                                      <p>{payment.payment_method === 1 ? "Razorpay" : "--"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Payment Reference ID: </b>
                                      </small>
                                      <p>{payment.payment_id || "N/A"}</p>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <b>Invoice/ receipt no: </b>
                                      </small>
                                      <p>{payment.payment_status_id === 1?getInvoiceNumber(memberDetails.application_no) : "N/A"}</p>
                                    </div>
                                  </React.Fragment>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <div className="col-md-12 pb-3">
                        <div className="last_form_submit_flex">
                          <div>
                            <button
                              onClick={() => handleViewMemberPopup(false)}
                              className="btn  btn-outline-danger btn-block saveand_proced_button"
                              type="button"
                            >
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            ) : <Loader />}
          </div>
        </div>
      )}
      {viewMemberActivityPopupStatus && (
        <div
          className={`extraspace_search_div search_div${viewMemberActivityPopupStatus ? " open" : ""}`}
        >
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>Activity</h3>
              <div className="input-group-append d-flex gap-10">
                <span
                  onClick={() => handleViewMemberActivityPopup(false)}
                  className="search_toggle btn btn-danger"
                >
                  <i className="fa fa-times"></i>
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <div className="body application_body_side activity_popup_div">
                <fieldset>
                  <Tabs defaultActiveKey="home" id="uncontrolled-tab-example">
                    <Tab
                      eventKey="home"
                      title="Activity"
                      tabClassName="custom_tab"
                      className="chatapp_body"
                    >
                      <div className="chat-history">
                        <div className="message_data">
                          <ul>
                            {memberActivityData && memberActivityData.length > 0 ? (
                              memberActivityData.map((data, index) => (
                                <li key={index} className="right clearfix">
                                  <div className="message bg-success text-white">
                                    <span>{data.status_name}</span>
                                  </div>
                                  <span className="data_time">{formatTimestamp(data.created_on)}</span>
                                </li>
                              ))
                            ) : (
                              <div className="nodata_siv bg-danger text-white">
                                <p>No Activity Available</p>
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="profile"
                      title="My Notes"
                      tabClassName="custom_tab"
                      className="chatapp_body"
                    >
                      <div className="chat-history">
                        <div className="message_data">
                          <ul>
                            {memberNotesData && memberNotesData.length > 0 ? (
                              memberNotesData.map((data, index) => (
                                <li key={index} className="right clearfix">
                                  <div className="message bg-success text-white">
                                    <span>{data.notes}</span>
                                  </div>
                                  <span className="data_time">{formatTimestamp(data.created_on)}</span>
                                </li>
                              ))
                            ) : (
                              <div className="nodata_siv bg-danger text-white">
                                <p>No Notes Available</p>
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="pt-5">
                        <div className="form-group">
                          <textarea
                            rows="4"
                            className="form-control no-resize"
                            placeholder="Your notes here..."
                            value={notesValue}
                            onChange={(e) => setNotesValue(e.target.value)}
                          />
                        </div>
                        <div className="align-right">
                          <button disabled={!notesValue} onClick={handleSaveMemberNotes} className="btn btn-primary">Submit</button>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="log"
                      title="Activity Log"
                      tabClassName="custom_tab"
                      className="chatapp_body"
                    >
                      <div className="chat-history">
                        <div className="message_data">
                          <ul>
                            {memberActivityLogData && memberActivityLogData.length > 0 ? (
                              memberActivityLogData.map((data, index) => {
                                const performedBy = data.performed_by ? `${data.performed_by.full_name} (${data.performed_by.role})` : 'Unknown';
                                let messageContent;

                                const formatColumnName = (col) => {
                                  return col.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                                };

                                if (data.action_type === 'INSERT') {
                                  messageContent = (
                                    <span>Inserted by {performedBy}</span>
                                  );
                                } else if (data.action_type === 'UPDATE') {
                                  const changesList = data.changes
                                    .filter(change => change.column !== 'id' && change.column !== 'created_on' && change.column !== 'updated_on' && change.old_value !== change.new_value)
                                    .map(change => (
                                      <div key={change.column}>
                                        Changed {formatColumnName(change.column)} from "{change.old_value ?? 'null'}" to "{change.new_value ?? 'null'}"
                                      </div>
                                    ));

                                  messageContent = (
                                    <>
                                      <span>Updated by {performedBy}</span>
                                      {changesList.length > 0 && (
                                        <div>
                                          {changesList}
                                        </div>
                                      )}
                                    </>
                                  );
                                } else {
                                  messageContent = <span>{data.action_type} by {performedBy}</span>;
                                }

                                return (
                                  <li key={index} className="right clearfix">
                                    <div className="message bg-success text-white">
                                      {messageContent}
                                    </div>
                                    <span className="data_time">
                                      {data.created_on ? formatTimestamp(data.created_on) : 'N/A'}
                                    </span>
                                  </li>
                                );
                              })
                            ) : (
                              <div className="nodata_siv bg-danger text-white">
                                <p>No Activity Available</p>
                              </div>
                            )}
                          </ul>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      )}
      {invoiceError && <p className="text-danger">{invoiceError}</p>}
      {showInvoice && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backgroundColor: "#000000ad",
            padding: "20px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            overflow: "auto",
          }}
        >
          <button
            onClick={handleCloseInvoice}
            className="search_toggle btn btn-danger search_tracking_div"
          >
            <i className="fa fa-times"></i>
          </button>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <Invoice invoiceData={invoiceData} />
          </div>
        </div>
      )}
      {showMembershipCertificate && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backgroundColor: "#000000ad",
            padding: "20px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            overflow: "auto",
          }}
        >
          <button
            onClick={handleCloseMembershipCertificate}
            className="search_toggle btn btn-danger search_tracking_div"
          >
            <i className="fa fa-times"></i>
          </button>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <MembershipCertificate
              certificateDetails={certificateDetails}
              firstName={memberDetails.first_name}
              middleName={memberDetails.middle_name}
              lastName={memberDetails.last_name}
              applicationName={applicationName}
              membershipNumber={memberDetails.membership_no}
              membershipDate={convertCertificateDate(memberDetails.member_reg_date)}
            />
          </div>
        </div>
      )}
      {showFMASCertificate && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            backgroundColor: "#000000ad",
            padding: "20px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            overflow: "auto",
          }}
        >
          <button
            onClick={handleCloseFMASCertificate}
            className="search_toggle btn btn-danger search_tracking_div"
          >
            <i className="fa fa-times"></i>
          </button>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <FMASCertificate
              certificate={`${baseUrl}/${fmasDetails.certificate_file}`}
              firstName={memberDetails.first_name}
              middleName={memberDetails.middle_name}
              lastName={memberDetails.last_name}
              applicationName={applicationName}
              membershipNumber={memberDetails.membership_no}
              membershipDate={convertCertificateDate(memberDetails.member_reg_date)}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ViewMembershipApplicationComponent;